import React, { useEffect } from 'react'
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import useSearchMember from '../../../hooks/fetchUsers'
import { communicationStateModel } from './CommunicationStateModel'
import { CommunicationDataTable } from './CommunicationDataTable'
import { communicationSearchSchema } from './communitacionSearchSchema'

export const Communication = () => {
  const URL = 'Outbox'
  const target = {
    OutboxType: 'Communication'
  }

  const { renderUsers, handleObject, loading, customData } = useSearchMember(URL,target)

  
useEffect(() => {
    document.title = 'TPA® Admin - Comunicaciones'
  }, [])


  return (
    <>

      <SearchContainer
        handleObject={handleObject}
        searchSchema={communicationSearchSchema}
              selectListOptions={[]}
      />

      <CommunicationDataTable

        stateModel={communicationStateModel}
        currentPagination={customData.current}
        usersData={renderUsers}
        handleObject={handleObject}
        loading={loading}
        memberShip={false} //👉 activa el modal de informacion del miembro
        alert={false} //👉 activa el modal de alerta de acciones 
      />

    </>
  )
}
